<div class="container">
  <h3>Project Overview</h3>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>{{ project?.contractTitle }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Contract No.</td>
        <td>{{ project?.contractNo }}</td>
      </tr>
      <tr>
        <td>Client</td>
        <td>{{ project?.client }}</td>
      </tr>
      <tr>
        <td>Consultant</td>
        <td>{{ project?.consultant }}</td>
      </tr>
      <tr>
        <td>Type of contract</td>
        <td>{{ project?.typeOfContract }}</td>
      </tr>
      <tr>
        <td>Form of contract</td>
        <td>{{ project?.formOfContract }}</td>
      </tr>
      <tr>
        <td>Contract Value</td>
        <td>{{ project?.contractValue }}</td>
      </tr>
      <tr>
        <td>Start Date</td>
        <td>{{ project?.startDate }}</td>
      </tr>
      <tr>
        <td>Completion Date</td>
        <td>{{ project?.completionDate }}</td>
      </tr>
      <tr>
        <td>Duration</td>
        <td>{{ project?.duration }}</td>
      </tr>
      <tr>
        <td>Maintenance Period</td>
        <td>{{ project?.maintenancePeriod }}</td>
      </tr>
      <tr>
        <td>Status</td>
        <td>{{ project?.status }}</td>
      </tr>
    </tbody>
  </table>
</div>
